import { Injectable } from '@angular/core';
import { AddressDetail, AddressType } from '../shared/models/address-detail';

@Injectable({
  providedIn: 'root'
})
export class AddressValidationService {

  constructor() { }


  addressFromPlaceResult(place: google.maps.places.PlaceResult, addressType: AddressType) {
    let address = {} as AddressDetail;

    if (place === undefined) {
      return;
    }

    if (addressType === AddressType.establishment) {
      address.name = place.name;
    }

    if (!place.address_components) {
      address.isEmpty = true;
      return;
    }

    for (const component of place.address_components as google.maps.GeocoderAddressComponent[]) {
      // @ts-ignore remove once typings fixed
      const componentType = component.types[0];

      switch (componentType) {
        case "street_number": {
          address.addressLine1 = `${component.long_name} ${address.addressLine1 ?? ''}`;
          break;
        }

        case "route": {
          address.addressLine1 += component.short_name;
          break;
        }

        case "postal_code": {
          address.postCode = `${component.long_name}`;
          break;
        }

        case "locality":
          address.suburb = component.long_name;
          break;

        case "administrative_area_level_1": {
          address.state = component.short_name;
          break;
        }

        case "country":
          address.country = component.long_name;
          break;
      }

      address.isEmpty = (!address.addressLine1 && !address.country && !address.name && !address.postCode && !address.state && !address.suburb)
    }

    return address
  }
}
